import React from "react";
import "./components.css";

const tops = [25, 42, 60, 78];

const Band = ({ top = 0 }) => (
  <div
    className="band"
    style={{
      top: `${tops[top]}%`
    }}
  ></div>
);

const Bands = ({ band }) =>
  [0, 1, 2, 3].map(n => (n === band ? <div key={n} /> : <Band key={n} top={n} />));

const Slide = ({ path, band, handler, classes }) => (
  <div className={`slide ${classes}`} onClick={handler} style={{ backgroundImage: `url(${path})` }}>
    <Bands band={band} />
  </div>
);

export default Slide;
